import React from 'react'
import { FaCheckCircle } from "react-icons/fa";
import { FaRankingStar } from "react-icons/fa6";


function PageSection({bg,data ,reverse}) {
  return (
    <div className='w-full flex justify-center mt-12 '>
        {data?.map((e) => ( 
        <div   className={`w-full sm:w-[90%] lg:w-[85%] 2xl:w-[78%] h-max sm:min-h-[620px] ${ reverse ? 'flex-col-reverse lg:flex-row-reverse xl:gap-12' : 'flex-col lg:flex-row' }  gap-7   py-[40px] flex px-[4.5%] sm:py-[5%] ${ bg ? 'bg-[#fafafa]' : 'bg-white' }  sm:rounded-[50px]`}>       
    <div className='w-full lg:w-[50%] flex flex-col gap-5 justify-start h-full'>
    <div className=''>     
            <span className='flex text-[16px] items-center gap-2 semibold text-blue-700 mb-3'>
              <span className='text-2xl'>{e.icon}</span>{e.iconTitle}</span>  
            <span className='bold text-[20px] sm:text-[24px] lg:text-[32px]'>{e.title}</span>    
</div>
<div className='regular  break-words flex flex-col items-start gap-6 lg:gap-4 text-[15px]  mt-5'>
      {e.lines.map((el) => (    
      <div className='regular  break-words flex items-start gap-3 text-sm lg:text-[15px]'>
       <span ><FaCheckCircle className='fill-blue-500 text-[15px] mt-1 ' /></span>
       <span className=''>{el} </span>
       </div>
       ))}
 </div>
   
       
           
         
    </div>
    <div className=' w-full lg:w-[50%] '>
      {/* {console.log(e)} */}
       <img className=' aspect-auto rounded-[40px]' src={e.image} alt="" />
    </div>
 </div>))}
   
 </div>
  )
}

export default PageSection
